export type StatusBarFlag = 'PIN_POINT_INDICATOR' | 'PIN_POINT_SEARCH';

export const statusBarFlagsItems: { [key: string]: StatusBarFlag } = {
	pinPointIndicator: 'PIN_POINT_INDICATOR',
	pinPointSearch: 'PIN_POINT_SEARCH',
};



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/status-bar/models/status-bar-flag-items.model.ts